import { render, staticRenderFns } from "./joinUsDetail.vue?vue&type=template&id=5e2bdf16&"
import script from "./joinUsDetail.vue?vue&type=script&lang=js&"
export * from "./joinUsDetail.vue?vue&type=script&lang=js&"
import style0 from "./joinUsDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports